// Environment configuration with dotenv
// Requires: npm install dotenv


// Environment configuration
export const environment = {
  // Other environment variables...
  
  // Get encryption keys from environment variables
  API_ENC_KEY: process.env.REACT_APP_API_ENC_KEY || "default-dev-key",
  API_ENV_IV: process.env.REACT_APP_API_ENV_IV || "default-dev-iv"
}; 